/// <reference types="@types/googlemaps" />
import { Component, OnInit, ViewChild, ElementRef, NgZone, OnDestroy, ChangeDetectorRef, AfterViewChecked, AfterViewInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { DataSharingService } from '../../../services/data-sharing.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackbarService } from '../../../_service/message-service';
import { MapsAPILoader } from '@agm/core';
import { AuthenticationService } from 'src/app/_services';
import { StationService } from 'src/app/_services/station.service';
import { User } from '../../../_models';
import { VendorService } from '../../../../app/_services/vendor.services';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { ChargeBoxService } from 'src/app/_services/chargebox/chargebox.service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { MenuRouteID } from '../../header/menu-item/nav-item';
import { TariffManagementService } from '../../tariff-management/services/tariff-management-service';
import { CreateTariffComponent } from '../../tariff-management/create/create-tariff.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { AutoCompleteComponent } from 'src/app/shared/components/auto-complete/auto-complete.component';

declare var $: any;

@Component({
  selector: 'telio-add-station',
  templateUrl: './add-station.component.html',
  styleUrls: ['./add-station.component.scss']
})
export class AddStationComponent implements OnInit, OnDestroy {
  @ViewChild('search', { static: false }) searchElementRef: ElementRef;
  @ViewChild(AutoCompleteComponent) autoComplete: AutoCompleteComponent;
  // public searchElementRef: ElementRef;
  public searchChange(event) { };
  addStation: UntypedFormGroup;
  submitted = false;
  test = false;
  items: UntypedFormArray;
  lat: number = null;
  lng: number = null;
  zoom: number;
  address: string = '';
  private geoCoder;
  currentUser: User;
  editcase: boolean;
  editdata: any = {};
  loginDataIS: any;
  stndetails: any;
  list: any = [];
  tariffList: any = [];
  operatorList: any = [];
  operatorListdata: any = [];
  latitude;
  longitude;
  adminrole: any;
  porttypeList: string[] = [];
  acPorts: string[] = [];
  dcPorts: string[] = [];
  unit: any;
  selectedVendor = '';
  uploadedPhotos: any[] = [];
  alphabetsfewsplch: RegExp = /^[ A-Za-z_.]*$/;
  userNameexp: RegExp = /^[^-\s][\w\s-]+$/;
  numbersandonech: RegExp = /^[0-9]* [ A-Za-z]{1}$/;
  whitespace: RegExp = /^([^\s]*[A-Za-z0-9]\s*)[^\s]*$/;
  numbers: RegExp = /^[0-9]*$/;
  numbersdot: RegExp = /^[0-9 .]*$/;
  floatnumber: RegExp = /^([0-9]*|\d*\.\d{1}?\d*)$/;
  currentuser: any = {};
  vendorid: any;
  vendormailid: any;
  selectedFile = null;
  selectedFilePreview = null;
  count = 0;
  templat;
  templng;
  searchData: any;
  vendorlist: any = [];
  disableAdd;
  showMultiConnectorBox: boolean = false;
  totalPower: number = 0;
  connectorArr;
  newConnector;
  removeDisabled: boolean = false;
  numberOfRowsArr;
  multiConnectorArray;
  getports: Subscription;
  amenitiesList = [];
  List: any = [];
  amenitiesArr;
  newAmenity;
  tabIndex = 0;
  stationId;
  status;
  listClone: any = [];
  routedComponent: string;
  photosList = [{ key: 1, value: null }, { key: 2, value: null }];
  cpoId;
  vendorEmail;
  disableTariffForCPO = false;
  totalAddress = {
    pincode: '',
    country: '',
    city: '',
    state: ''
  };
  availableTabs = [
    { id: MenuRouteID.TABS.GENERAL_DETAILS, enable: false },
    { id: MenuRouteID.TABS.AMENITIES, enable: false },
    { id: MenuRouteID.TABS.STATION_IMAGES, enable: false }
  ];
  driverEmail;
  stationmanagerEmail;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dataSharingService: DataSharingService,
    private router: Router,
    private toastr: SnackbarService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private stationService: StationService,
    private userInfoService: UserInfoService,
    private tariffService: TariffManagementService,
    private vendorservice: VendorService,
    public translate: TranslateService,
    public dialog: MatDialog,
    readonly chargeboxService: ChargeBoxService,
    private cdr: ChangeDetectorRef
  ) { }

  checkForInvalidCharacters(event, inputBox) {
    if ((event.which != 46 || inputBox.val().indexOf('.') != -1) && (event.which < 48 || event.which > 57)) {
      event.preventDefault();
    }
  };

  onFileSelected1(event) {
    this.selectedFile = event.target.files[0];
    var fileName = this.selectedFile.name
    var imageSize = event.target.files[0].size
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (imageSize > 1048576) {
      this.toastr.error(this.translate.instant('createStation.imgSizeError'))
      event.target.value = null;
      return false
    }
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
      return true
    } else {
      this.toastr.error(this.translate.instant('createStation.imgTypeError'));
      event.target.value = null;
      return false
    }
  }

  onFileSelected(event) {
    let x = event.target.files[0];
    this.selectedFile = x;
    var fileName = x.name
    var imageSize = x.size
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (imageSize > 1048576) {
      this.toastr.error(this.translate.instant('createStation.uploadimgSizeError'))
      event.target.value = null;
      return false
    }
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
      let reader = new FileReader();
      let url;
      reader.onload = () => {
        url = reader.result;
        this.selectedFilePreview = url;
      };
      reader.readAsDataURL(x);
    } else {
      this.toastr.error(this.translate.instant('createStation.imgTypeError'));
      event.target.value = null;
      return false
    }
  }

  ngOnInit() {
    this.availableTabs = this.userInfoService.getPermittedTabs(+this.route.snapshot.paramMap.get('routeID'), this.availableTabs);
    let tabExists = this.availableTabs.filter(res => res.enable);
    !tabExists || tabExists.length == 0 ? this.toastr.info(this.translate.instant('unAuthorized')) : '';
    this.route.queryParams.subscribe(params => {
      this.routedComponent = params['routedName'];
      this.vendorEmail = params['vendorId']
      !!this.vendorEmail && this.getTariffsByVendorID(this.vendorEmail)
      this.stationId = params['stationId'];
      if (this.routedComponent == 'deviceAmenities')
        this.tabIndex = 1;
      else if (this.routedComponent == 'devicePhotos')
        this.tabIndex = 2;
    });
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
          this.zoom = 12;
          this.getAddress(this.lat, this.lng)
        });
      });
    });
    this.currentuser = this.userInfoService.userDetails;
    this.vendormailid = this.userInfoService.userDetails.email;
    if (this.userInfoService.isAdminGroup()) {
      this.adminrole = true;
      !this.stationId && this.getvendorlist();
      this.getOperatorList(this.vendorEmail)
    }
    else {
      this.adminrole = false;
      this.vendorid = JSON.stringify(this.currentuser.id);
      this.getTariffsByVendorID(this.vendormailid);
      if (this.stationId) {
        this.disableTariffForCPO = (this.vendorEmail == this.vendormailid) ? false : true
      }
      if (!this.adminrole) {
        this.getOperatorList(this.vendormailid)
      }
    }
    if (this.stationId) {
      this.adminrole && this.getvendorlist()
      this.getstationamenties();
    }
    this.getporttypes();
    this.addStation = new UntypedFormGroup({
      name: new UntypedFormControl(),
      vendorType: new UntypedFormControl(),
      stationManager: new UntypedFormControl(),
      numberOfCharger: new UntypedFormControl(),
      Address: new UntypedFormControl(),
      pinCode: new UntypedFormControl(),
      latitude: new UntypedFormControl(),
      longitude: new UntypedFormControl(),
      multiconnectors: new UntypedFormControl(),
      type: new UntypedFormControl(),
      portType: new UntypedFormControl(),
      powerOutput: new UntypedFormControl(),
      tariffId: new UntypedFormControl(),
      voltageRating: new UntypedFormControl(),
      comminicationMedium: new UntypedFormControl(),
      pricePerUnit: new UntypedFormControl(),
      stationid: new UntypedFormControl(),
      image: new UntypedFormControl(),
      connectors: new UntypedFormArray([]),
      amenities: new UntypedFormArray([])
    });

    if (!this.stationId) {
      setTimeout(() => {
        if (this.userInfoService.isAdminGroup()) {
          this.addStation = this.formBuilder.group({
            vendorType: [null, Validators.compose([
              Validators.required,
            ])],
            stationManager: [null],
            name: [null,
              Validators.compose([Validators.required, Validators.pattern(this.userNameexp)])],
            numberOfCharger: [null, Validators.compose([
              Validators.required,
            ])],
            Address: ['', Validators.required],
            pinCode: [null, [Validators.required, Validators.pattern(this.numbers)]],
            stationid: ['', Validators.compose([Validators.required, Validators.pattern(this.whitespace)])],
            latitude: [this.lat],
            longitude: [this.lng],
            multiconnectors: ['', Validators.required],
            type: [null, Validators.compose([
              Validators.required,
            ])],
            powerOutput: [{
              value: this.totalPower,
              disabled: true
            }, Validators.compose([

              Validators.pattern(this.floatnumber)
            ])],
            voltageRating: [null, Validators.compose([
              Validators.required,
              Validators.pattern(this.floatnumber)
            ])],
            comminicationMedium: ['', Validators.required],
            pricePerUnit: [null],
            connectors: new UntypedFormArray([

            ]),
            amenities: this.amenitiesArr ? this.amenitiesArr : new UntypedFormArray([])

          });
        }
        else {
          this.addStation = this.formBuilder.group({
            stationManager: [null],
            name: [null,
              Validators.compose([Validators.required, Validators.pattern(this.userNameexp)])],
            numberOfCharger: [null, Validators.compose([
              Validators.required,
            ])],
            Address: ['', Validators.required],
            pinCode: [null, [Validators.required, Validators.pattern(this.numbers)]],
            stationid: ['', Validators.compose([Validators.required, Validators.pattern(this.whitespace)])],
            latitude: [this.lat],
            longitude: [this.lng],
            multiconnectors: ['', Validators.required],
            type: [null, Validators.compose([
              Validators.required,
            ])],
            powerOutput: [{
              value: this.totalPower,
              disabled: true
            }, Validators.compose([

              Validators.pattern(this.floatnumber)
            ])],
            voltageRating: [null, Validators.compose([

              Validators.pattern(this.floatnumber)
            ])],
            comminicationMedium: ['', Validators.required],
            pricePerUnit: [null],
            connectors: new UntypedFormArray([]),
            amenities: this.amenitiesArr ? this.amenitiesArr : new UntypedFormArray([])

          });
        }

      }, 1500);
    }

    let localInfo = this.authenticationService.getlocalInfo.subscribe(local => {
      this.unit = local ? local.currencySymbol : this.translate.instant('rs');
    });
  }
  addConnector() {
    this.connectorArr = this.addStation.get('connectors') as UntypedFormArray
    const connectorId = this.connectorArr.length + 1;
    this.newConnector = this.formBuilder.group({
      'connectorId': [{ value: connectorId, disabled: true }],
      'portType': ['', Validators.required],
      'powerOutput': ['', Validators.compose([
        Validators.required,
        , Validators.pattern(this.floatnumber)
      ])],
      'tariffId': [null, Validators.compose([Validators.required,])],
    })
    this.newConnector.get('tariffId').valueChanges
      .subscribe(typedvalue => {
        this.List = typedvalue ? this.filter(typedvalue) : this.listClone;
      })

    if (this.connectorArr.value.length < 4) {
      this.connectorArr.push(this.newConnector);
      this.newConnector.controls['connectorId'].disable();
    }
    else {
      this.toastr.error(this.translate.instant('stationList.maxConnectors'));
      return;
    }
    this.disableCheck()
  }
  addAmenities() {
    this.amenitiesArr = this.addStation.get('amenities') as UntypedFormArray
    this.amenitiesList.map(x => x.amenities.map(a => {
      let amen = this.amenitiesArr.controls.filter(y => y.controls['category'].value == x.category && y.controls['title'].value == a);
      if (amen.length == 0)
        this.amenitiesArr.push(this.getAmenity(x.category, a));
    }));
  }
  getAmenity(category, title) {
    return this.formBuilder.group({
      id: '',
      category: [category],
      title: [title],
      enable: ['']
    });
  }
  totalPowerOutput() {
    this.totalPower = 0;
    !!this.connectorArr && !!this.connectorArr.value && this.connectorArr.value.forEach((res: any, i: number) => {
      !!this.connectorArr.value[i] ? (this.totalPower += +this.connectorArr.value[i].powerOutput) : null;
    })
    this.totalPower = parseFloat(this.totalPower.toFixed(3));
  }
  disableCheck() {
    this.removeDisabled = !!this.connectorArr && (this.connectorArr.length <= 1) ? true : false;
  }
  connectorchange() {
    this.showMultiConnectorBox = true;
    let noOfChargers = this.addStation.controls['numberOfCharger'].value;
    if (this.addStation.controls['multiconnectors'].value == "No") {
      this.disableAdd = true;
      this.removeDisabled = true;
      this.addStation.controls["numberOfCharger"].patchValue("1");
      if (this.connectorArr == undefined) {
        this.addConnector();

      }
      else if (this.connectorArr.value.length > 1) {
        const value1 = this.connectorArr.at(0);
        this.connectorArr.clear();
        this.connectorArr.push(value1);
      }
      this.numberOfRowsArr = [0]
    }
    else {
      this.addStation.controls["numberOfCharger"].patchValue('2');
      this.numberOfRowsArr = [0, 1];
      this.disableAdd = false;
      this.removeDisabled = false;

      if (this.connectorArr == undefined) {
        this.addConnector();
        this.addConnector();
      }
      else if (this.connectorArr.value.length == 1) {
        this.addConnector();
      }

    }
    this.totalPowerOutput();
  }
  onChangeNumberOfRows(numberOfRows) {
    let noOfConnectors = numberOfRows.value;
    if (noOfConnectors == 3) {
      if (this.connectorArr.length == 2) {
        this.addConnector()
      }
      else if (this.connectorArr.length == 4) {
        this.connectorArr.removeAt(3)
      }
    }
    if (noOfConnectors == 4) {
      if (this.connectorArr.length == 2) {
        this.addConnector();
        this.addConnector();
      }
      if (this.connectorArr.length == 3) {
        this.addConnector();
      }
    }
    if (noOfConnectors == 2) {
      const value1 = this.connectorArr.at(0);
      const value2 = this.connectorArr.at(1);
      this.connectorArr.clear();
      this.connectorArr.push(value1);
      this.connectorArr.push(value2)
    }
    this.totalPowerOutput();
  }
  connectorDetails() {
    this.showMultiConnectorBox = true;
    this.addConnector();
  }
  removeConnector(i) {
    this.connectorArr.removeAt(i);
    this.disableCheck()

  }

  get isAdmin() {
    return this.userInfoService.groups && this.userInfoService.isAdminGroup();
  }
  createItem(): UntypedFormGroup {
    return this.formBuilder.group({
    });
  }

  addItem(): void {
    this.items = this.addStation.get('items') as UntypedFormArray;
    this.items.push(this.createItem());
    if (this.count === this.addStation.value['numberOfCharger']) {
      this.test = false;
    } else {
      this.test = true;
    }
  }
  get f() { return this.addStation.controls; }

  onSubmit() {
    !!this.connectorArr && this.connectorArr.value.forEach((ele: any, i: number) => {
      this.connectorArr.value[i].connectorId = i + 1;
      this.connectorArr.value[i]['chargingStatus'] = 'Unavailable';
      this.connectorArr.value[i]['connector_image'] = this.connectorArr.value[i].portType;
      this.connectorArr.value[i].tariffId = this.getTariffId(this.connectorArr.value[i].tariffId)
    })
    this.stndetails = this.addStation.value;
    this.submitted = true;
    if (this.lat == null || this.lng == null) {
      this.toastr.error(this.translate.instant('createStation.locationError'));
      return
    }
    if (this.selectedFile == null && !this.stationId) {
      this.toastr.error(this.translate.instant('createStation.imgError'));
      return
    }

    if (this.addStation.valid) {
      if (this.addStation.value.name == 0) {
        this.toastr.error(this.translate.instant('createStation.nameError2'));
        return;
      }
      else if (this.addStation.value.stationid == 0) {
        this.toastr.error(this.translate.instant('createStation.idError2'))
        return;
      }
      this.stndetails = this.addStation.value;
      const formData = new FormData();
      if (this.userInfoService.isAdminGroup()) {
        let request = {
          chargeboxId: this.stationId ? this.stationId : this.stndetails.stationid,
          name: this.stndetails.name,
          type: this.stndetails.type,
          vendorId: this.selectedVendor,
          power: this.totalPower,
          vrating: this.stndetails.voltageRating,
          medium: this.stndetails.comminicationMedium,
          latitude: this.lat,
          longitude: this.lng,
          address: this.stndetails.Address,
          multiConnector: this.stndetails.multiconnectors,
          connectors: this.connectorArr.value,
          status: this.status ? this.status : 'Available',
          amenities: this.amenitiesArr.value,
          state: this.totalAddress.state,
          country: this.totalAddress.country,
          pinCode: this.stndetails.pinCode,
          city: this.totalAddress.city,
          stationManager: this.getStationEmail(this.stndetails.stationManager),
        };

        const dataTemp = new Blob([JSON.stringify(request)], {
          type: 'application/json'
        });
        if (!!this.selectedFile) {
          formData.append('image', this.selectedFile)
        }
        formData.append('chargebox', dataTemp);
      }
      else {
        let request = {
          chargeboxId: this.stationId ? this.stationId : this.stndetails.stationid,
          name: this.stndetails.name,
          type: this.stndetails.type,
          vendorId: this.vendormailid,
          power: this.totalPower,
          vrating: this.stndetails.voltageRating,
          medium: this.stndetails.comminicationMedium,
          latitude: this.lat,
          longitude: this.lng,
          address: this.stndetails.Address,
          multiConnector: this.stndetails.multiconnectors,
          connectors: this.connectorArr.value,
          status: this.status ? this.status : 'Available',
          amenities: this.amenitiesArr.value,
          state: this.totalAddress.state,
          country: this.totalAddress.country,
          pinCode: this.stndetails.pinCode,
          city: this.totalAddress.city,
          stationManager: this.getStationEmail(this.stndetails.stationManager),
        };
        const dataTemp = new Blob([JSON.stringify(request)], {
          type: 'application/json'
        });
        if (!!this.selectedFile) {
          formData.append('image', this.selectedFile, this.selectedFile.name)
        }
        formData.append('chargebox', dataTemp);
      }
      if (!this.stationId) {
        this.stationService.savestation(formData).subscribe(
          (resp: any) => {
            if (resp.statusCode === 409) {
              this.toastr.error(resp.message);
            }
            if (resp.statusCode === 400) {
              this.toastr.error(resp.message)
            }
            else if (resp != null) {
              this.toastr.success(resp);
              this.router.navigate(['/dashboard/stations', { routeID: MenuRouteID.STATIONS }]);
            }
            else {
              this.toastr.error(resp)
            }

          },
          error => {
            this.toastr.error(error.message);
          }
        );
      }
      else {
        this.stationService.updatestation(formData).subscribe(
          (resp: any) => {
            if (resp.statusCode === 400) {
              this.toastr.error(resp.message);
              return;
            }
            if (resp != null) {
              this.toastr.success(resp);
              this.navigateTo();
            }
          },
          error => {
            this.toastr.error(error.message);
          }
        ),
          error => {
            this.toastr.error(error.message);
          };
      }
    }
    else {
      return;
    }
  }

  openGoogelMapsModal() {
    $("#mappopup").modal('show');
    this.addStation.controls["latitude"].patchValue(this.lat);
    this.addStation.controls["longitude"].patchValue(this.lng);
    this.searchData = "";
    if (!this.lat || !this.lng) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: any) => {
          if (position) {
            this.lat = position.coords.latitude;
            this.lng = position.coords.longitude;
            this.getAddress(this.lat, this.lng);
          }
        });
      }
    }
  }

  // Get Current Location Coordinates
  setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = this.addStation.controls.latitude.value ? this.addStation.controls.latitude.value : 17.385044;
        this.lng = this.addStation.controls.longititue.value ? this.addStation.controls.longititue.value : 78.486671;
        this.zoom = 15;
        this.getAddress(this.lat, this.lng);
      });
    }
  }

  markerDragEnd($event) {
    this.lat = $event.coords.lat;
    this.lng = $event.coords.lng;
    this.getAddress(this.lat, this.lng);
    this.addStation.patchValue({
      latitude: this.lat,
      longitude: this.lng
    });
    $("#mappopup").modal('hide');

  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.addStation.value.longititue = this.lng
          this.addStation.value.latitude = this.lat
          let totalAddress = results[0].address_components
          totalAddress.forEach((ele, i) => {
            switch (ele.types[0]) {
              case 'postal_code':
                this.totalAddress.pincode = ele.long_name;
                break
              case 'locality':
                this.totalAddress.city = ele.long_name
                break
              case 'country':
                this.totalAddress.country = ele.short_name
                break;
              case 'administrative_area_level_1':
                this.totalAddress.state = ele.short_name;
                break;
              default:
                break;
            }
          })
          let shortAdd = []
          totalAddress.forEach((ele, i) => {

            if (ele.types.includes('premise')) {
              shortAdd.push(ele.short_name)
              return
            }
            else if (ele.types.includes('street_number')) {
              shortAdd.push(ele.short_name)
              return
            }
            else if (ele.types.includes('route')) {
              shortAdd.push(ele.short_name)
              return
            }
            else if (ele.types.includes('neighborhood')) {
              shortAdd.push(ele.short_name)
              return
            }
            else if (ele.types.includes('sublocality')) {
              shortAdd.push(ele.short_name)
              return
            }
            else {
              return
            }
          })
          this.address = shortAdd.join(' ')
          this.addStation.controls.Address.setValue(this.address)
          this.addStation.controls.Address.updateValueAndValidity()
          this.addStation.controls.pinCode.setValue(this.totalAddress.pincode)
          this.addStation.controls.pinCode.updateValueAndValidity()
        } else {
          this.toastr.error(this.translate.instant('stationList.noResults'));
          this.clearAddress()
        }
      } else {
        this.toastr.error(this.translate.instant('stationList.geoCoderFailed') + status);
        this.clearAddress();
      }
    });
  }

  getvendorlist() {
    this.vendorservice.getAllVendors(1,1000,'','asc','').subscribe(
      ((resp: any) => {
        this.vendorlist = resp.content;
        !!this.vendorlist && this.vendorlist.forEach((ele: any, i: number) => {
          this.list.push({
            'name': this.vendorlist[i].name,
            'id': this.vendorlist[i].vendor_id,
          })
        });
        if (!!this.stationId) {

          if (this.adminrole) {
            this.addStation.controls.vendorType.patchValue(this.getVendorName(this.vendorEmail));
            this.addStation.controls.vendorType.setValidators(Validators.required);
            this.addStation.controls.vendorType.updateValueAndValidity();
          }
          else {
            this.addStation.controls.vendorType.setValue(this.cpoId);
            this.addStation.controls.vendorType.setValidators(null);
            this.addStation.controls.vendorType.updateValueAndValidity();
          }
        }
      })
    );
  }

  getporttypes() {
    this.getports = this.vendorservice.getporttypelist().subscribe(
      ((res: any) => {
        if (res) {
          this.acPorts = res.acPortType
          this.dcPorts = res.dcPortType;
          if (this.stationId) {
            setTimeout(() => {
              if (this.addStation.controls['type'].value == 'AC') {
                this.porttypeList = this.acPorts
              }
              else {
                this.porttypeList = this.dcPorts
              }
            }, 1000)
          }
        }
        else {
          this.acPorts = []
          this.dcPorts = []
        }
        if (res && res.amenities) {
          this.amenitiesList = Object.keys(res.amenities).map(x => {
            return {
              category: x,
              amenities: res.amenities[x]
            }
          });
          if (!this.stationId)
            this.addAmenities();
        }
      })
    )
  }

  ngOnDestroy() {
    this.getports && this.getports.unsubscribe();
  }

  topback() {
    if (this.addStation.dirty) {
      this.confirmCancel();
    }
    else {
      if (this.stationId)
        this.navigateTo();
      else
        this.navigateStationList();
    }
  }

  confirmCancel(): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('createStation.cancelmessage') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        if (this.stationId)
          this.navigateTo();
        else
          this.navigateStationList();
      }
    });
  }

  navigateStationList() {
    this.router.navigate(['/dashboard/stations', { routeID: MenuRouteID.STATIONS }]);
  }

  back() {
    this.tabIndex = 0;
  }

  next() {
    this.tabIndex = 1;
  }

  amenitiesnext() {
    this.tabIndex = 2;
  }

  uploadsback() {
    this.tabIndex = 1;
  }

  onChange(event: MatTabChangeEvent) {
    this.tabIndex = event.index
  }

  getstationamenties() {
    this.stationService.getStationDataById(this.stationId).subscribe((data: any) => {
      if (data) {
        this.status = data.status;
        this.cpoId = data.vendorId;
        this.totalPower = data.power;
        // data.stationManager && this.getOperatorList(data.vendorId)
        this.driverEmail = data.stationManager;
        this.driverEmail && this.getUsernameByEmail(this.driverEmail, this.operatorList)
        this.addStation.controls.name.setValue(data.name);
        this.addStation.controls.name.setValidators(Validators.compose([
          Validators.required,
          Validators.pattern(this.userNameexp)]));
        this.addStation.controls.name.updateValueAndValidity();
        this.addStation.controls.stationid.setValue(data.chargeboxId);
        this.addStation.controls.stationid.disable();
        this.addStation.controls.stationid.updateValueAndValidity();
        this.addStation.controls.comminicationMedium.setValue(data.medium);
        this.addStation.controls.comminicationMedium.updateValueAndValidity();
        this.selectedFilePreview = data.url;
        if (data.amenitiesUrl) {
          let photos = data.amenitiesUrl.replace(' ', '').split('#');
          photos.map(x => {
            let index = x.lastIndexOf("_");
            if (index > -1) {
              let k = x.substring(index + 1, index + 2);
              this.photosList[k - 1] = ({ key: k, value: x });
            }
          });

          if (this.photosList.length == 0) {
            photos.map((x, i) => {
              this.photosList[i] = ({ key: i + 1, value: x });
            })
          }
        }

        this.addStation.controls.type.setValue(data.type);
        this.addStation.controls.type.setValidators(Validators.required);
        this.addStation.controls.type.updateValueAndValidity();
        this.addStation.controls.multiconnectors.setValue(this.userInfoService.capitalizeFirstLetter(data.multiConnector));
        this.addStation.controls.multiconnectors.updateValueAndValidity();
        this.addStation.controls.powerOutput.setValue(this.totalPower);
        this.addStation.controls.powerOutput.disable();
        this.addStation.controls.powerOutput.setValidators(Validators.compose([
          , Validators.pattern(this.numbersdot)]));
        this.addStation.controls.powerOutput.updateValueAndValidity();
        this.addStation.controls.voltageRating.setValue(data.vrating);
        this.addStation.controls.voltageRating.setValidators(Validators.compose([
          Validators.pattern(this.floatnumber)
        ]));
        this.addStation.controls.voltageRating.updateValueAndValidity();
        this.addStation.controls.latitude.setValue(data.latitude);
        this.addStation.controls.latitude.setValidators(Validators.required);
        this.addStation.controls.latitude.updateValueAndValidity();
        this.addStation.controls.longitude.setValue(data.longitude);
        this.addStation.controls.longitude.setValidators(Validators.required);
        this.addStation.controls.longitude.updateValueAndValidity();
        this.addStation.controls.Address.setValue(data.address);
        this.addStation.controls.Address.setValidators(Validators.required);
        this.addStation.controls.pinCode.setValue(data.pinCode);
        this.addStation.controls.pinCode.setValidators(Validators.required);
        this.addStation.controls.pinCode.updateValueAndValidity();
        this.lat = data.latitude;
        this.lng = data.longitude;
        this.address = data.address;
        this.totalAddress.city = data.city;
        this.totalAddress.country = data.country
        this.totalAddress.pincode = data.pinCode
        this.totalAddress.state = data.state
        this.connectorArr = this.addStation.get('connectors') as UntypedFormArray
        this.setTariff(data);

        this.amenitiesArr = this.addStation.get('amenities') as UntypedFormArray
        data.amenities.forEach(element => {
          if (element.title != "Air")
            this.amenitiesArr.push(this.formBuilder.group({
              id: element.id,
              category: [element.category],
              title: [element.title],
              enable: [element.enable]
            }))
        });

        this.addAmenities();
        if (this.searchElementRef) {
          this.mapsAPILoader.load().then(() => {
            this.setCurrentLocation();
            this.geoCoder = new google.maps.Geocoder;

            let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
            autocomplete.addListener("place_changed", () => {
              this.ngZone.run(() => {
                let place: google.maps.places.PlaceResult = autocomplete.getPlace();
                if (place.geometry === undefined || place.geometry === null) {
                  return;
                }
                this.lat = place.geometry.location.lat();
                this.lng = place.geometry.location.lng();
              });
            });
          });
        }

      }
    });
  }

  navigateTo() {
    if (this.routedComponent === 'deviceAmenities' || this.routedComponent === 'deviceSpec' || this.routedComponent == 'devicePhotos') {
      this.router.navigate(['/dashboard/stations/details', { routeID: MenuRouteID.STATIONS }], { queryParams: { "stationid": JSON.stringify(this.stationId) } })
    }
    else if (this.routedComponent === 'vendorStations') {
      this.router.navigate(['/dashboard/operators/details', { routeID: MenuRouteID.OPERATORS }], { queryParams: { "vendorid": JSON.stringify(this.cpoId), index: '1' } })
    }
    else {
      this.router.navigate(['/dashboard/stations', { routeID: this.route.snapshot.paramMap.get('routeID') }], { queryParams: { "state": true } });
    }

  }

  onUpload(event, index) {
    if (this.uploadedPhotos.length <= 2) {
      let x = event.target.files[0];
      var fileName = x.name
      var imageSize = x.size
      var idxDot = fileName.lastIndexOf(".") + 1;
      var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
      if (imageSize > 1048576) {
        this.toastr.error(this.translate.instant('createStation.uploadimgSizeError'))
        event.target.value = null;
        return false
      }
      if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
        let reader = new FileReader();
        let url;
        reader.onload = () => {
          url = reader.result;
          this.photosList[index] = ({ key: index + 1, value: url });
          this.uploadedPhotos.push({ key: index + 1, file: x });
          this.uploadFiles({ key: index + 1, file: x });
        };
        reader.readAsDataURL(x);
      } else {
        this.toastr.error(this.translate.instant('createStation.imgTypeError'));
        event.target.value = null;
        return false
      }
    }
    else {
      this.toastr.error(this.translate.instant('createStation.uploadCountError'));
      event.target.value = null;
      return false
    }
  }

  deleteuploads(i) {
    this.photosList[i].value = null;
    let index = this.uploadedPhotos.findIndex(x => x.key == i + 1);
    this.uploadedPhotos.splice(index, 1);
  }

  deleteurls(i) {
    let decodParsing = decodeURIComponent(this.photosList[i].value);
    if (decodParsing.indexOf('/chargebox') != -1) {
      let index = decodParsing.lastIndexOf("/");
      let filename = decodParsing.substring(index + 1);

      this.stationService.deletePhoto(this.stationId, filename).subscribe(x => {
        if (x) {
          this.toastr.success(this.translate.instant('faq.deleteSuccess'));
          this.photosList[i].value = null;
        }
      })
    }
    else {
      this.deleteuploads(i);
    }
  }

  uploadFiles(x) {
    var index = x.file.name.lastIndexOf(".") + 1;
    var ext = x.file.name.substr(index).toLowerCase();
    const formDataa = new FormData();
    formDataa.append('chargeboxId', this.stationId);
    formDataa.append('pathFolder', 'IMAGES');
    let random = 100000 + Math.floor(Math.random() * 900000)
    formDataa.append('file', x.file, this.addStation.controls.name.value + "_" + random + "_" + x.key + "." + ext);
    this.stationService.uploadImage(formDataa).subscribe(res => {
      if (x) {
        this.toastr.success(this.translate.instant('faq.addSuccess'));
      }
    })
  }

  getAddresses(event, type) {
    if (type == 'lat' && !isNaN(event.target.value))
      this.lat = Number(event.target.value);
    else if (type == 'lng' && !isNaN(event.target.value))
      this.lng = Number(event.target.value);
    if (this.lat && this.lng)
      this.getAddress(this.lat, this.lng);
    else
      this.clearAddress();

  }

  clearAddress() {
    this.addStation.controls.latitude.setValue(this.lat);
    this.addStation.controls.latitude.setValidators(Validators.required);
    this.addStation.controls.latitude.updateValueAndValidity();
    this.addStation.controls.longitude.setValue(this.lng);
    this.addStation.controls.longitude.setValidators(Validators.required);
    this.addStation.controls.longitude.updateValueAndValidity();
    this.address = "";
    this.totalAddress.city = "";
    this.totalAddress.state = "";
    this.totalAddress.country = "";
    this.totalAddress.pincode = "";
  }

  getIcon(amenity) {
    return this.chargeboxService.getAmenitiesIcon(amenity);
  }

  portChange(event) {
    let portType = event
    this.porttypeList = (portType == 'AC') ? this.acPorts : this.dcPorts
  }

  private filter(name: string) {
    const filterValue = name.toLowerCase();
    return this.listClone.filter(
      (option: any) => option.name.toLowerCase().includes(filterValue)
    );
  }

  getTariffsByVendorID(email) {
    this.tariffService.getTariffByOperatorId(email).subscribe(
      ((resp: any) => {
        this.tariffList = resp.content
      })
    );
  }


  clearSelectedTariff() {
    const connectorArray = this.addStation.controls.connectors['controls']
    for (let index = 0; index < connectorArray.length; index++) {
      connectorArray[index].controls.tariffId.setValue(null);
      connectorArray[index].controls.tariffId.updateValueAndValidity()
    }
  }

  createTariff(i) {
    let tempTariff = this.addStation.controls.connectors['controls'][i].controls.tariffId.value;
    !!tempTariff ? this.authenticationService.setAddStationTariff(tempTariff) : this.authenticationService.setAddStationTariff('');
    if (this.userInfoService.isAdminGroup()) {
      this.authenticationService.setOperatorForTariff(this.selectedVendor)
    }
    else {
      this.authenticationService.setOperatorForTariff(this.vendormailid)
    }
    this.authenticationService.setTariffDialog(true);
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '95%',
      height: '80vh',
      maxWidth: '95%',
      maxHeight: '80vh',
      data: { component: CreateTariffComponent, title: this.translate.instant('tarrif.create.popupTitle') }
    }).afterClosed().subscribe((res: any) => {
      this.updatedList();
      this.addStation.controls.connectors.value[i].tariffId = this.authenticationService.getAddStationTariff();
      this.addStation.controls.connectors['controls'][i].controls.tariffId.setValue(this.authenticationService.getAddStationTariff());
      this.addStation.controls.connectors['controls'][i].controls.tariffId.setErrors(null);
      this.addStation.controls.connectors.updateValueAndValidity();
    })
  }

  getVendorName(id) {
    if (!!id) {
      let vendor = this.list.find(res => res.id === id);
      this.selectedVendor = vendor.id;
      return !!vendor ? vendor.name : ''
    }
  }

  getTariffId(id) {
    if (!!id) {
      let tariff = this.tariffList.find(res => res.name === id);
      return !!tariff ? tariff.id : ''
    }
  }

  getSelectedValue(event) {
    this.selectedVendor = event;
    this.adminrole ? this.getOperatorList(this.selectedVendor) : this.getOperatorList(this.vendormailid)
    this.getTariffsByVendorID(this.selectedVendor)
  }

  updatedList() {
    if (this.userInfoService.isAdminGroup()) {
      this.getTariffsByVendorID(this.selectedVendor)
    } else {
      this.getTariffsByVendorID(this.vendormailid)
    }
  }

  getOperatorList(email) {
    this.vendorservice.getOperatorList(email).subscribe(
      ((resp: any) => {
        this.operatorListdata = resp
        !!this.operatorListdata && this.operatorListdata.forEach((ele: any, i: number) => {
          this.operatorList.push({
            'name': this.operatorListdata[i].username,
            'email': this.operatorListdata[i].email,
          })
        });
        // if(this.stationId){
        //   this.getUsernameByEmail(this.driverEmail, this.operatorList);
        // }
      })
    )
  }

  getUsernameByEmail(email, userArray) {
    const user = userArray.find(userObj => userObj.email === email);
    if (user) {
      this.stationmanagerEmail = user.email
      let operatorDrivername = user.name
      this.addStation.controls.stationManager.setValue(operatorDrivername);
      this.addStation.controls.stationManager.updateValueAndValidity();
    } else {
      return null;
    }
  }

  getStationEmail(email) {
    const isEmail = /\S+@\S+\.\S+/.test(email);
    if (isEmail) {
      return email;
    } else {
      const user = this.operatorList.find(userObj => userObj.name === email);
      if (user) {
        return user.email;
      } else {
        return null;
      }
    }
  }
  setTariff(data) {
    setTimeout(() => {
      if (data.connectors && data.connectors.length > 0 && data.connectors[0].connectors)
        data.connectors[0].connectors.forEach(c => {
          this.connectorArr.push(this.formBuilder.group({
            'connectorId': {
              value: c.connectorId,
              disabled: true
            },
            'portType': c.portType,
            'powerOutput': c.powerOutput,
            'tariffId': c.tariffName
          }))
          this.cdr.detectChanges()
          this.addStation.get('numberOfCharger').setValue(this.connectorArr.length.toString());
          this.addStation.controls.numberOfCharger.updateValueAndValidity();
          this.addStation.controls.tariffId.updateValueAndValidity();
          this.showMultiConnectorBox = true;
        });
      this.cdr.detectChanges()

    }, 1000)
  }
}
